module.exports = __webpack_public_path__ + "img/grin-beam.002fe324.svg";